import React from 'react';
import Link from 'next/link';
import { CDN2 } from '@/helpers/api';
import Image from 'next/image';

export default function CardCoupons({ airports, configInfo }) {
  const airportInitials = [
    'IAH',
    'DIA',
    'PDX',
    'DTW',
    'HOU',
    'BNA',
    'ATL',
    'SFO',
    'LGB',
    'ONT',
    'EWR',
    'LAS',
    'JFK',
    'CLT',
    'DFW',
  ];

  const filteredAirports = airports.result.filter((airport) =>
    airportInitials.includes(airport.airport_initials)
  );

  return (
    <>
      {filteredAirports.map((airport) => (
        <Link
          key={airport.airport_id}
          passHref
          href={`/parking-coupons/${airport.airport_initials}`}
        >
          <div className="border border-primary/50 p-6 flex flex-col overflow-hidden">
            <div className="relative w-full max-w-[20rem] h-[20rem] mx-auto">
              <Image
                src={`${CDN2()}/staticmyapp/coupons/${airport.airport_initials.toLowerCase()}.webp`}
                layout="fill"
                alt={`On Air Parking coupon for ${airport.airport_name}`}
                className="z-10"
                loading="eager"
              />
              <h3 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white z-20 text-xl md:text-4xl font-bold">
                SAVE ${configInfo.couponPageAppDiscount}
              </h3>
            </div>

            <div className="space-y-2">
              <h3 className="text-lg md:text-xl font-bold mt-4 flex items-center justify-center text-center min-h-[4rem]">
                {airport.airport_name} ({airport.airport_initials})
              </h3>
              <p className="text-base md:text-lg flex items-center justify-center text-center">
                Code: {airport.airport_initials}
                {configInfo.couponPageSuffix}
              </p>
            </div>
            <p className="text-center text-sm md:text-base text-primary font-bold mt-2">
              GET DEAL
            </p>
          </div>
        </Link>
      ))}
    </>
  );
}
